import type VueRouter from 'vue-router'
import type { Route } from 'vue-router'

import type { LoginAttemptResult } from '@/helpers/AuthExternal'
import { authenticationMethod } from '@/helpers/Environment'
import { withSellerPrefix } from '@/helpers/route'

import { logInTrackJS } from '@/errors/helpers'
import store from '@/store/store'

function isSFEC() {
  return authenticationMethod === 'sf_ecomm'
}

async function login(currentPath: string): Promise<LoginAttemptResult> {
  const cartId = store.getters['Cart/cart']?.id

  const params = new URLSearchParams({
    redirect: withSellerPrefix(currentPath),
    ...(cartId && { cart_id: cartId }),
  })

  const oauthEndpoint = '/api/sso/start'
  const oauthUrl = `${oauthEndpoint}?${params.toString()}`

  window.location.assign(oauthUrl)

  return { success: true }
}

function handleRedirectCallback(router: VueRouter, to: Route): LoginAttemptResult {
  const { auth_error: authError } = to.query

  if (!authError) return { success: true }

  logInTrackJS(`SFEC error: ${authError}`, Error(authError))

  return { success: false, error: Error('SFEC Authentication failed') }
}

export const sfec = {
  isSFEC,
  login,
  handleRedirectCallback,
}
;(window as Window & { __sfecForSpy?: typeof sfec }).__sfecForSpy = sfec
queueMicrotask(() => {
  window.__spyOn?.(sfec)
})

export type SFECClient = typeof sfec
